import handleLoad from './handleLoad';

/**
 * Attach interactions to every element that matches selector.
 */
$('.products').each((_, component) => {
    // detach and cache item template
    const $itemTemplate = $(component).find('.products__item[data-template]')
        .removeAttr('data-template')
        .detach();

    $(component)
        .on('filter:change', '.filter', handleLoad(component, $itemTemplate));

    $(window).on('load', handleLoad(component, $itemTemplate));
});



// WEBPACK FOOTER //
// ./src/scripts/components/products/index.js